import { COOKIES, MonthInMs } from "constants/enum";

export const storeIsLeadFromSmajla = () => {
    const expiresDate = new Date(Date.now() + 3 * MonthInMs);

    document.cookie = `${
        COOKIES.SMAJLA_SERVICE_IS_LEAD_FROM_SMAJLA_COOKIE
    }=true;path=/;expires=${expiresDate.toUTCString()}`;
};
